<form [formGroup]="form">
	<ngx-editor-menu [disabled]="control.disabled || readonly" [editor]="editor" [toolbar]="toolbar"> </ngx-editor-menu>
	<ngx-editor [ariaReadOnly]="readonly" [editor]="editor" formControlName="editorContent" outputFormat="html"></ngx-editor>
</form>
